import { TextField } from "@material-ui/core";
import { TextValidator } from "react-material-ui-form-validator";
import { getValidations } from "../../../helpers/validations/getValidations";

export const ValidatorInputField = (props) => {
  const { variant, endAdornment, validations = [], ...otherProps } = props;
  const { validators, errorMessages } = validations ? getValidations(validations) : [];

  return (
    <TextValidator
      {...otherProps}
      validators={validators}
      errorMessages={errorMessages}
      variant={variant || 'standard'}
      InputProps={{ endAdornment }}
      autoComplete="off"
      autoFocus={false}
      fullWidth
    />
  );
};

export const InputField = (props) => {
  const { variant, endAdornment, ...otherProps } = props;

  return (
    <TextField
      {...otherProps}
      variant={variant || 'standard'}
      InputProps={{ endAdornment }}
      autoComplete="off"
      fullWidth
    />
  );
};

